var MDConvert = function(fn) {
  if(MDConvert.done)
    fn();
  else
    MDConvert.afterConvertFns.push(fn);
};
MDConvert.afterConvertFns = [];

$(function() {
  var converter = new Remarkable();
  $('.mdconvert').each(function() {
    var $this = $(this);
    var md = $this.find('textarea').val();
    $this.html(converter.render(md));
    $this.removeClass('mdconvert');
  });
  MDConvert.done = true;
  _.each(MDConvert.afterConvertFns, function(fn) { fn(); });
});



// WEBPACK FOOTER //
// ./public/javascripts/mdconvert.js